import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class ComParentChildService {

private subjects: Subject<string>[] = [];

publish(eventName: string) {
// ensure a subject for the event name exists
this.subjects[eventName] = this.subjects[eventName] || new Subject();

// publish event
this.subjects[eventName].next();
}

on(eventName: string) {
// ensure a subject for the event name exists
this.subjects[eventName] = this.subjects[eventName] || new Subject();

// return observable
return this.subjects[eventName].asObservable();
}

}


// WEBPACK FOOTER //
// ./src/app/services/parent-child.service.ts